import React from 'react'

function Icon({ width = 34, height = 20 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 30 18"
    >
      <path
        fill="#552588"
        d="M28.5 0h-27C.656 0 0 .703 0 1.5v15c0 .844.656 1.5 1.5 1.5h27c.797 0 1.5-.656 1.5-1.5v-15c0-.797-.703-1.5-1.5-1.5zm-27 1.5h3c0 1.688-1.36 3-3 3v-3zm0 15v-3c1.64 0 3 1.36 3 3h-3zm27 0h-3c0-1.64 1.313-3 3-3v3zm0-4.5c-2.484 0-4.5 2.063-4.5 4.5H6C6 14.062 3.937 12 1.5 12V6C3.938 6 6 3.984 6 1.5h18C24 3.984 26.016 6 28.5 6v6zm0-7.5c-1.688 0-3-1.313-3-3h3v3zM15 3c-2.906 0-5.25 2.719-5.25 6 0 3.328 2.344 6 5.25 6 2.86 0 5.25-2.672 5.25-6 0-3.281-2.39-6-5.25-6zm0 10.5c-2.11 0-3.75-2.016-3.75-4.5 0-2.438 1.64-4.5 3.75-4.5 2.063 0 3.75 2.063 3.75 4.5 0 2.484-1.688 4.5-3.75 4.5zm1.5-2.953h-.75V6.422a.37.37 0 00-.375-.375h-.656c-.235 0-.469.047-.61.187l-.75.47c-.14.093-.187.327-.093.515l.421.61c.094.187.329.234.516.093h.047V10.5h-.75a.37.37 0 00-.375.375v.75c0 .234.14.375.375.375h3a.37.37 0 00.375-.375v-.75c0-.188-.188-.375-.375-.328z"
      ></path>
    </svg>
  )
}

export default Icon
